import resolveConfig from 'tailwindcss/resolveConfig';

const fullConfig = resolveConfig(process.env.TAILWIND_CONFIG as any);

export default fullConfig;
